import { Col, Row } from "antd";
import classNames from "classnames";
import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import QuickActionRed from "shared/components/SVG/LMF/QuickActionRed";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";
import Button from "../Button";
import InfoBox from "../InfoBox";
import Input from "../Input";
import InputChecked from "../svg/check_small.svg";
import InputError from "../svg/error.svg";
import validation from "./validation";

const View = ({
  setOpen,
  onSubmit,
  initialValues,
  errorMessages,
  TRANSLATION,
}) => {
  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues,
    onSubmit: onSubmit,
    validationSchema: validation(errorMessages),
  });
  return (
    <div className="lmfhelp__modal--content">
      <div className="lmfhelp__modal--head">
        <span
          className="lmfhelp__modal--title"
          dangerouslySetInnerHTML={{ __html: TRANSLATION.TITLE }}
        ></span>
      </div>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Input
            label={TRANSLATION.FORM.LAST_NAME.LABEL}
            placeholder={TRANSLATION.FORM.LAST_NAME.PLACEHOLDER}
            {...bindInputProps({
              name: `contact.user.lastname`,
              values,
              setFieldValue,
              ...formProps,
            })}
            onChange={({ target: { value } }) => {
              setFieldValue(`contact.user.lastname`, value);
            }}
            className={classNames({
              valid: get(values, "contact.user.lastname"),
            })}
            suffix={
              get(formProps.errors, `contact.user.lastname`) ? (
                <img src={InputError} alt="" />
              ) : (
                <img src={InputChecked} alt="" />
              )
            }
            required
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Input
            label={TRANSLATION.FORM.FIRST_NAME.LABEL}
            placeholder={TRANSLATION.FORM.FIRST_NAME.PLACEHOLDER}
            {...bindInputProps({
              name: `contact.user.firstname`,
              values,
              setFieldValue,
              ...formProps,
            })}
            onChange={({ target: { value } }) => {
              setFieldValue(`contact.user.firstname`, value);
            }}
            className={classNames({
              valid: get(values, "contact.user.firstname"),
            })}
            suffix={
              get(formProps.errors, `contact.user.firstname`) ? (
                <img src={InputError} alt="" />
              ) : (
                <img src={InputChecked} alt="" />
              )
            }
            required
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Input
            label={TRANSLATION.FORM.PHONE.LABEL}
            placeholder={TRANSLATION.FORM.PHONE.PLACEHOLDER}
            inputMode="numeric"
            {...bindInputProps({
              name: `contact.telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
              values,
              setFieldValue,
              ...formProps,
            })}
            onChange={({ target: { value } }) => {
              setFieldValue(
                `contact.telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
                value,
              );
            }}
            className={classNames({
              valid: get(
                values,
                `contact.telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
              ),
            })}
            suffix={
              get(
                formProps.errors,
                `contact.telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
              ) ? (
                <img src={InputError} alt="" />
              ) : (
                <img src={InputChecked} alt="" />
              )
            }
            required
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Input
            label={TRANSLATION.FORM.EMAIL.LABEL}
            placeholder={TRANSLATION.FORM.EMAIL.PLACEHOLDER}
            {...bindInputProps({
              name: `contact.telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
              values,
              setFieldValue,
              ...formProps,
            })}
            onChange={({ target: { value } }) => {
              setFieldValue(
                `contact.telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
                value,
              );
            }}
            className={classNames({
              valid: get(
                values,
                `contact.telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
              ),
            })}
            suffix={
              get(
                formProps.errors,
                `contact.telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
              ) ? (
                <img src={InputError} alt="" />
              ) : (
                <img src={InputChecked} alt="" />
              )
            }
            required
          />
        </Col>
      </Row>
      <InfoBox
        text={TRANSLATION.AGREEMENT}
        icon={<QuickActionRed />}
        variant="info"
      />

      <div className="lmfhelp__modal--actions">
        <Button
          onClick={() => setOpen(false)}
          className="w-40"
          type="white"
          size="large"
        >
          <span>{TRANSLATION.CLOSE}</span>
        </Button>
        <Button
          disabled={
            !isEmpty(formProps.errors) || !get(values, "contact.user.firstname")
          }
          onClick={handleSubmit}
          type={!isEmpty(formProps.errors) ? "white" : "primary"}
          size="large"
          className="w-full"
        >
          <span>{TRANSLATION.CONFIRM}</span>
        </Button>
      </div>
    </div>
  );
};

export default View;
